<template>
  <section class="wrapper">
    <van-row class="mt10">
      <van-col :span="6">
        <van-button block size="small">记录增值税</van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='taxation'?'primary':'default'"
                    @click="goto('taxation')">记录营业税金及附加</van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" @click="goto('sale')">记录所得税</van-button>
      </van-col>
      <van-col :span="6" @click="find()">
        <van-button block size="small" @click="goto('findfee')">查询税费</van-button>
      </van-col>
    </van-row>
    <router-view class="content"></router-view>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        currentUrl: ''
      }
    },
    methods: {
      Recordincome() {
        this.$router.push({path: '/Recordincome'})
      },
      sale() {
        this.$router.push({path: '/sale'})
      },
      find() {
        this.$router.push({path: '/findfees'})
      },
      goto(url) {
        this.$router.push(`/tax/${url}`)
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          const urlArray = to.path.split('/');
          this.currentUrl = urlArray[urlArray.length - 1];
        },
        immediate: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    padding: 0 1rem;
    overflow: hidden;

    .content {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      height: calc(100% - 20rem);
      overflow: auto;
      /*background:white;*/
      box-sizing: border-box;
    }
  }
</style>
